import PropTypes from 'prop-types';

import { STATUS_MODES } from '../constants';

import { When } from 'react-if';

import './StatusInfo.scss';

const StatusInfo = ({ progress, mode, width }) => {
  const progressCalculated = Math.round(progress / 10)

  return (
    <div 
        className="status" 
        style={{ width: mode === STATUS_MODES.UPLOAD || mode === STATUS_MODES.PREPARE ? width : undefined }}
    >
    <When condition={progress === 0 && mode === STATUS_MODES.DOWNLOAD}>
      {() => (
        <div className="status__information">
          Downloading CSV file...
        </div>
      )}
    </When>
    <When condition={progress === 0 && mode === STATUS_MODES.PREPARE}>
      {() => (
        <div className="status__information">
          Preparing CSV file...
        </div>
      )}
    </When>
    <When condition={progress === 0 && mode === STATUS_MODES.UPLOAD}>
      {() => (
        <div className="status__information">
          File is uploading...
        </div>
      )}
    </When>
    <When condition={progress === 0 && mode === STATUS_MODES.CHECK}>
      {() => (
        <div className="status__information">
          Checking if table is valid...
        </div>
      )}
    </When>
    <When condition={progress > 0}>
      {() => (
        <div className="status__parsing__container">
          <span className="status__parsing__container__text">
            Parsing CSV file: {progressCalculated} %
          </span>
          <div 
              className="status__parsing__container__bar"
              style={{
                width: progressCalculated + "%"
              }}
          />
        </div>
      )}
    </When>
  </div>
  )
}

StatusInfo.propTypes = {
  mode: PropTypes.oneOf(["DOWNLOAD", "UPLOAD", "PREPARE", "CHECK"]).isRequired,
  progress: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired
}

export default StatusInfo;
